import { createAction, props } from '@ngrx/store';
import { Profile } from '../../../models/ccm/profile.model';
import { Review } from '../../../models/ccm/review.model';

export const addReview = createAction(
  '[Review] Add Review',
  props<{ review: Review }>()
);

export const addProfile = createAction(
  '[Review] Add Profile',
  props<{ profile: Profile }>()
);